import React from 'react';
import { hot } from 'react-hot-loader/root';

import { openActivityPopup } from '../../utils/openActivityPopup';
import RemoteApp from '../../utils/RemoteAppWrapper';

type KanbanAppProps = {
  externalData: Record<string, unknown>;
};

const KanbanApp = ({ externalData }: KanbanAppProps) => (
  <RemoteApp
    data={{
      scope: 'WorkstreamsUI',
      module: './KanbanApp',
      externalData: {
        ...externalData,
        analytics: {
          trackEvent: window.wb_track,
          eventProperties: { location: 'WORKSTREAM_PAGE', subLocation: 'KANBAN_TAB' },
        },
        onActivityClick: openActivityPopup,
      },
    }}
  />
);

export default hot(KanbanApp);
